
eval("define(\'text!htmlContent/pane.html\',[],function () { return \'<div id=\"{{id}}\" class=\"view-pane\">\\n    <div class=\"pane-header\"></div>\\n    <div class=\"pane-content\">\\n        <div class=\"not-editor\"></div>\\n    </div>\\n</div>\';});\n\n//# sourceURL=/text!htmlContent/pane.html");

